import { render, staticRenderFns } from "./ORegisterInfoEditComp.vue?vue&type=template&id=9acce48a&scoped=true&"
import script from "./ORegisterInfoEditComp.vue?vue&type=script&lang=ts&"
export * from "./ORegisterInfoEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./ORegisterInfoEditComp.vue?vue&type=style&index=0&id=9acce48a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acce48a",
  null
  
)

export default component.exports